// extracted by mini-css-extract-plugin
export default {"header":"Header_header__j3HRy","logo":"Header_logo__G3zlR","orangeLine":"Header_orangeLine__VoH6k"};